import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import { firebaseAuth, logComponentLoad, logDashboardAction} from '../../../../config/constants.js'
import axios from 'axios'
import { serverIp } from '../../../../config/constants.js'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants'

class GoogleSheetsUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authed: false,
            user: '',
            algoliaUser:'',
            loading:false
        }
    }

    componentDidMount() {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "GoogleSheetsUpdate");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }

    sendSuppliesToGoogleSheet = (orderNumber) => {
        console.log("+++++ sendSuppliesToGoogleSheet - " + orderNumber);

        this.setState({loading:true})

        var d = new Date();
        var tt = d.getTime();
        var ts = d.toDateString();

        axios.post(serverIp + 'googleSheets/writeToSheets', {
            apiKey: 'adfasdfdsf',
            userEmail: this.state.user.email
        })
            .then((response) => {
               // console.log("gsht15:"+JSON.stringify(response.data,null,3));

                this.setState({loading:false})

                if(response.data.result){
                    alert("Sucess:"+response.data.message);
                    logDashboardAction(this.state.user.email + " exported "+response.data.numRecords+" to google supply sheet", this.state.user.email, null, "GoogleSheetsUpdate");
                }else if(!response.data.result){
                    alert("Failed:"+response.data.message)
                    logDashboardAction(this.state.user.email + " Failed to  exported google supply sheet", this.state.user.email, null, "GoogleSheetsUpdate");
                }else{
                    alert("Failed: unknown error");
                    logDashboardAction(this.state.user.email + " Failed to  exported google supply sheet", this.state.user.email, null, "GoogleSheetsUpdate");
                }
               
            })
            .catch((error) => {
               // console.log(error);
               alert("Failed: unknown error");
               this.setState({oading:false})
            });
    }

    render() {


        const updateUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <div>
                <h1>1. PRESS THE BUTTON, QUERIES SUPPLIES WILL BE SENT TO:</h1>
                <Button onClick={this.sendSuppliesToGoogleSheet}>SEND SHEETS</Button>

                <h1> 2. GO TO THS GOOGLE SHEET BELOW </h1>
                {/* <h1><a href="https://docs.google.com/spreadsheets/d/1MNXMPml-MHCnDGD0iToyWveEIW0pj5K_BOyJexYwpbI/edit?usp=sharing" target="_blank">GO TO TEMP SHEET.</a> */}
                <h1><a href="https://docs.google.com/spreadsheets/d/1ha3dS8VhPSQaPCJISi-NiC8CgzUZYs-ScIMwwkC_pyc/edit?usp=sharing" target="_blank">GO TO TEMP SHEET.</a>
                </h1>

                

                <h1> 3. COPY THE CONTENTS TO THE NORMAL SUPPLIES SHEET </h1>
                <h1><a href="https://docs.google.com/spreadsheets/d/1a5jdcqkjUEwqTeZ877ExPrhUVwNigqHZPzFMq5G5aWY/edit?usp=shar" target="_blank">GOT TO NORMAL SUPPLIES SHEET.</a>
                </h1>

            </div>
            : <div>LOGIN FOOL</div>

            const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'


        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("sendSuppliesList")
            ? <div>

                {updateUI}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>
                {wholeUI}
            </div>
        )
    }
}

export default GoogleSheetsUpdate;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/GoogleSheetsUpdate/GoogleSheetsUpdate.js